export default __webpack_public_path__ + "static/media/selectUnselectedLavander.0e473230.svg";